export const getGenrePercentageAtCurrentStage = (
  currentStage: number | undefined,
  artistsStage: any
): number => {
  if (!currentStage) return 0;

  const totalArtists = artistsStage
    .filter((x: any) => x.careerStage <= currentStage)
    .map((x: any) => x.amountArtists)
    .reduce((acc: number, valor: number) => acc + valor, 0);

  if (totalArtists === 0) return 0;

  const amountArtistCurrentStage = artistsStage.find(
    (x: any) => x.careerStage === currentStage
  );

  const porcentage =
    (amountArtistCurrentStage.amountArtists / totalArtists) * 100;

  return roundUpToTwoDecimals(porcentage);
};

export const roundUpToTwoDecimals = (num: number) => {
  return Math.ceil(num * 100) / 100;
};
